import React, { useState, useEffect, } from "react";
import { Modal, Menu, } from "tea-component";
import SvgIcon from "../SvgIcon";
import "@/pages/home/assets/scss/page/home/components/versionPopup.scss"
import { versionListOpts, VersionItemType, VersionItemLocaleType, getTranslateVersionInfo } from './_config';
import { sysTypeOrEnvType, getSysEvnType } from './_config';
import { getVersionInfo, versionVisit } from '@/pages/home/services/versionPopup';
import VersionImg from "./VersionImg";
import VersionFigure from "./VersionFigure";
import { isJSONFormartStr, getLogFormSystype } from './_config';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { useIntl, getLocale } from 'umi';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
// 首次加载弹出版本

export default function VersionDetails(props: any) {
  let {
    autoPopup,
    visible,
    detailsReback = () => console.log,
    closeDetails = () => console.log,
    versionName,
    activeModule = sysTypeOrEnvType.sys_type_dataBrain,
  } = props
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isCN = getLocale() === LANGUAGE_CN;
  //使用环境：用于发送查询参数
  const sysEnv = getSysEvnType();
  const [menuList, setMenuList] = useState<any[]>([])
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [activeVersionInfo, setActiveVersionInfo] = useState<VersionItemLocaleType | null>(null);
  const [versionList, setVersionList] = useState/*<IVersion[]>*/([]);//整个Detail列表菜单及内容数据
  const [activeVersionName, setActiveVersionName] = useState(versionName);
  const [activeSysType, setActiveSysType] = useState(activeModule);//当前的菜单高亮哪个系统    默认值为当前系统，或跳转过来的值，或点击系统值
  useEffect(() => {
    getVersionList();
  }, [])

  useEffect(() => {
    //当接口调用错误且重新打开Detail窗口时，重新请求接口
    if (visible && error) {
      getVersionList();
    }
  }, [error, visible])

  const getVersionList = async () => {
    setLoading(true)
    try {
      const params = {
        "sys_env": sysEnv
      }
      const res = await getVersionInfo(params);
      const _versionsList = res?.version_list || [];
      let _menuList: any = []
      versionListOpts.forEach((item) => {
        let menuItem: any = item;
        item.list = [];
        _versionsList.forEach((t: VersionItemType) => {
          if (t?.sys_type === item.sysType) {
            const localeVersion = getTranslateVersionInfo(t, locale)
            menuItem.list.push(localeVersion)
          }
        })
        _menuList.push(menuItem)
      })
      setMenuList(_menuList)
      setVersionList(_versionsList);
      setError(false);
    } catch (e) {
      console.error(e);
      setError(true);
    }
    setLoading(false)
  }

  useEffect(() => {
    if (visible) {
      initVersion(versionList, activeModule);
      setActiveSysType(activeModule);
    }
  }, [visible, activeModule, versionList])

  const initVersion = async (versions: VersionItemType[], selectType = activeSysType, selectName = '') => {
    setLoading(true)
    if (Array.isArray(versions) && versions.length) {
      /**当前高亮对应系统的对应版本和对应内容 */
      const activeVersion = versions.find((item) => {
        const localeItem = getTranslateVersionInfo(item, locale)
        return (item?.sys_type === selectType) && (localeItem?.version_name === selectName)
      }) || versions.find((item) => {
        return (item?.sys_type === selectType)
      }) || versions[0]

      const localeActiveVersion = await getTranslateVersionInfo(activeVersion, locale)
      setActiveVersionInfo(localeActiveVersion);
      setActiveSysType(activeVersion?.sys_type)
      setActiveVersionName(localeActiveVersion?.version_name);
      /**打点 */
      buriedPointPage(getLogFormSystype(activeVersion?.sys_type));
      /**首个直接发已读，可能是直接跳转过来的 */
      visited(activeVersion?.sys_type, localeActiveVersion?.version_name_api || '');
    }
    setLoading(false)
  };

  const visited = async (sysType: number, versionName: string) => {
    await versionVisit({
      "sys_env": sysEnv,
      "sys_type": sysType,
      "version_name": versionName
    })
  }
  const getMenuItemProps = (sysType: number, versionName: string) => {
    const id = `${sysType}-${versionName}`
    const lastActiveId = `${activeSysType}-${activeVersionName}`;
    return {
      selected: lastActiveId === id,
      onClick: () => {
        //防止在当前菜单一直点
        if (lastActiveId === id) {
          return;
        }
        initVersion(versionList, sysType, versionName);
      },
    }
  };

  return (
    <Modal className="version-details" visible={visible}
      caption={
        autoPopup ? formatMessage({ id: 'dbh_versionhistory_detail' })
          : <div className="version-details-title" onClick={detailsReback}>
            <SvgIcon type="left-pointing" className="version-details-icon" />
            <span className="version-details-text">{formatMessage({ id: 'dbh_versionhistory_detail' })}</span>
          </div>
      }
      size={1000}
      onClose={closeDetails}>
      <Modal.Body>
        <div className="version-details-context">
          <div className="details-left">
            <Menu className="details-left-menu">
              {menuList.map(e => {
                return <Menu.SubMenu
                  key={e.sysType}
                  title={<div className="menu-flex">
                    <SvgIcon type={e.icon} className="menu-icon" />
                    {isCN ? e?.title_cn : e.title}
                  </div>}
                  defaultOpened={e.sysType === activeSysType}
                >
                  {
                    !e.list?.length ? null : e.list.map((t: VersionItemLocaleType) => {
                      return <Menu.Item
                        className="menu-text"
                        key={t?.version_name}
                        title={<div className="menu-overflow">{t?.version_name}</div>}
                        {...getMenuItemProps(e.sysType, t?.version_name)}
                      />
                    })
                  }
                </Menu.SubMenu>
              })}

            </Menu>
          </div>
          {!loading && (
            isJSONFormartStr(activeVersionInfo?.version_content || '') ?
              <PicContext
                sysType={activeSysType}
                versionName={activeVersionInfo?.version_name}
                versionContent={activeVersionInfo?.version_content}
              /> : <TextContext
                versionName={activeVersionInfo?.version_name}
                versionContent={activeVersionInfo?.version_content}
              />)
          }


        </div>
      </Modal.Body>
    </Modal >
  )
}

const PicContext = (props: any) => {
  const { sysType, versionName, versionContent, } = props;

  if (sysType === sysTypeOrEnvType.sys_type_globalPedia)
    return <VersionFigure versionName={versionName} versionContent={versionContent} />;

  return <div className="details-right">
    <div className="details-right-date">{versionName}</div>
    <VersionImg
      versionName={versionName}
      versionContent={versionContent}
    />
  </div>
}

const TextContext = (props: any) => {
  const { versionName, versionContent } = props;
  return <div className="details-other-right">
    <div className="details-title">{versionName}</div>
    <div className="details-text" dangerouslySetInnerHTML={{ __html: versionContent }}>
    </div>
  </div>
}
